import React, { useState } from 'react';
import List from 'antd/lib/list';
import styles from './Metadata.module.scss';
import { isEmpty } from 'underscore';
import { Button, Modal } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

export default function MetadataList(props: { data: { [key: string]: any } }) {
  const [modalState, setModalState] = useState({ visible: false, image: '' });

  const showModal = (imgSrc: string) => {
    setModalState({ visible: true, image: imgSrc });
  };

  const handleCancel = () => {
    setModalState({ visible: false, image: '' });
  };

  return (
    <>
    <List
      className={styles.metadataList}
      size="small"
      bordered
      dataSource={Object.keys(props.data)}
      renderItem={(key) => {
        if (key === 'Illustration (Image)') {
          const { name, link_img } = props.data[key];
          return (
            <List.Item className={styles.row}>
              <div className={styles.rowTitle}>{key}</div>
              <div className={styles.rowDetail}>
                <div>{name}</div>
                <img
                  style={{ maxWidth: 170, cursor: 'pointer' }}
                  src={link_img}
                  alt={key}
                  onClick={() => showModal(link_img)}
                  />
              </div>
            </List.Item>
          );
        } else if (
          key === 'Geographical Range' ||
          key === 'Temporal Range'
        ) {
          const list = props.data[key] as string[];
          const displayValue = list.join('\n')

          return (
            <List.Item className={styles.row}>
              <div className={styles.rowTitle}>{key}</div>
              <div className={`${styles.rowDetail} ${styles.geographicalCoverage}`}>
                {isEmpty(list) ? '--' : displayValue}
              </div>
            </List.Item>
          );
        } else if (key === 'Geographical Coverage') {
          const data = props.data[key];
          const displayValue = Array.isArray(data) ? data.join('\n') : data;

          return (
            <List.Item className={styles.row}>
              <div className={styles.rowTitle}>{key}</div>
              <div className={`${styles.rowDetail} ${styles.geographicalCoverage}`}>
                {isEmpty(data) ? '--' : displayValue}
              </div>
            </List.Item>
          );
        } else if (key === 'Name (Unit)') {
          const list = (props.data[key].values || []) as string[];
          return (
            <List.Item className={styles.row}>
              <div className={styles.rowTitle}>{key}</div>
              <div className={styles.rowDetail}>
                {list.map((content, index) => {
                  return <div key={index}>{content}</div>;
                })}
              </div>
            </List.Item>
          );
        } else if (key === 'References (Links)') {
          const isArray = Array.isArray(props.data[key]);
          const empty = isEmpty(props.data[key]);
          const links = isArray
            ? props.data[key]
            : empty
            ? []
            : props.data[key].link
            ? [
                {
                  name: props.data[key].name
                    ? props.data[key].name
                    : 'Reference',
                  link: props.data[key].link,
                },
              ]
            : [];
          return (
            <List.Item className={styles.row}>
              <div className={styles.rowTitle}>{key}</div>
              <div className={styles.rowDetail}>
                {links.map((link: any, index: number) => {
                  return (
                    link &&
                    link.link && (
                      <div key={index} className={styles.row}>
                        <div
                          className={styles.link}
                          onClick={() => {
                            window.open(link.link);
                          }}
                        >
                          {link.name}
                        </div>
                      </div>
                    )
                  );
                })}
              </div>
            </List.Item>
          );
        } else if (key === 'Sample Data (.csv)') {
          const { name, link } = props.data[key];
          {
            return (
              props.data?.[key] && (
                <List.Item className={styles.row}>
                  <div className={styles.rowTitle}>{key}</div>
                  <div className={styles.rowDetail}>
                    <Button
                      type="primary"
                      icon={<DownloadOutlined />}
                      size="small"
                      onClick={() => {
                        window.open(link);
                      }}
                    >
                      {name}
                    </Button>
                  </div>
                </List.Item>
              )
            );
          }
        } else {
          return (
            <List.Item className={styles.row}>
              <div className={styles.rowTitle}>{key}</div>
              <div className={styles.rowDetail}>
                {isEmpty(props.data[key]) ? '--' : props.data[key]}
              </div>
            </List.Item>
          );
        }
      }}
    />
    <Modal
      open={modalState.visible}
      footer={null}
      onCancel={handleCancel}
      style={{
        minWidth: '850px',
        minHeight: '850px',
        maxWidth: '1000px',
        maxHeight: '1000px',
      }}
      zIndex={99999}
    >
      <img
        src={modalState.image}
        alt="Full Screen"
        style={{
          width: '100%',
          height: '100%',
        }}
      />
    </Modal>
  </>
  );
}
